'use client';

import { LotteryListHeader as CommonLotteryListHeader } from '@monorepo/common';
import type { Route } from 'next';
import { useRouter } from 'next/navigation';

function LotteryListHeader({
  query,
}: {
  query?: string;
}) {
  const router = useRouter();

  const handleSearch = (searchText: string) => {
    const params = new URLSearchParams(location.search);
    if (searchText.length > 0) {
      params.set('q', searchText);
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  return <CommonLotteryListHeader query={query} onSearch={handleSearch} />;
}

export default LotteryListHeader;
